import { constant } from '@config/BaseSetting';
import useLocalStorage from '@hooks/useLocalStorage';
import { useGetAuditLogsActorRolesMutation } from '@services/WebApiService/AuditLogApi';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import ITAutocomplete from '@ui/Components/ITAutocomplete';

function convertToOptions(actorRoles) {
  const result = [];

  Object.keys(actorRoles).forEach((k) => {
    result.push({
      value: k,
      label: actorRoles[k],
    });
  });

  return result;
}

export default function ActorRolesFilterSection({ partnerId, value, onChange }) {
  const [accessTokenSet] = useLocalStorage(constant.ACCESS_TOKEN_STORAGE);
  const [getAuditLogsActorRoles, getAuditLogsActorRolesState] = useGetAuditLogsActorRolesMutation();

  useEffect(() => {
    getAuditLogsActorRoles({
      accessToken: accessTokenSet,
      params: { distributor_id: partnerId },
    });
  }, [partnerId]);

  const options = useMemo(() => {
    if (!getAuditLogsActorRolesState.data?.actor_roles) return [];
    return convertToOptions(getAuditLogsActorRolesState.data?.actor_roles);
  }, [getAuditLogsActorRolesState.data]);

  const loading =
    getAuditLogsActorRolesState.isUninitialized || getAuditLogsActorRolesState.isLoading;

  return (
    <ITAutocomplete
      multiple
      disableCloseOnSelect
      options={options}
      value={value}
      onChange={onChange}
      label="Roles"
      placeholder="Select Roles"
      loading={loading}
    />
  );
}

ActorRolesFilterSection.propTypes = {
  partnerId: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

ActorRolesFilterSection.defaultProps = {
  partnerId: 0,
  value: '',
  onChange: () => {},
};
